import { render, staticRenderFns } from "./resourceApplyDetail.vue?vue&type=template&id=687472d8&scoped=true&"
import script from "./resourceApplyDetail.vue?vue&type=script&lang=js&"
export * from "./resourceApplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./resourceApplyDetail.vue?vue&type=style&index=0&id=687472d8&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687472d8",
  null
  
)

export default component.exports